import React, { useState } from 'react';
import axios from 'axios';
import { Mail, RefreshCw, Send } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { API } from '../context/AuthContext';

const badge = (ok, text) => (
  <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${ok ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700'}`}>{text}</span>
);

export const AdminEmailStatus = () => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const check = async (sendTest) => {
    setBusy(true); setError('');
    try {
      const r = await axios.get(`${API}/admin/email/status`, { params: sendTest ? { send_test: 1 } : {}, withCredentials: true });
      setData(r.data);
    } catch (e) { setError(e?.response?.data?.detail || e.message); }
    setBusy(false);
  };

  const d = data;
  const verified = d?.domain?.status === 'verified';
  return (
    <Card className="rounded-2xl p-4 border-gray-200 space-y-3" data-testid="admin-email-status-card">
      <div className="flex items-center gap-2 text-sm font-bold text-gray-800"><Mail size={16} /> Email (Resend) ସ୍ଥିତି</div>
      <div className="flex gap-2">
        <Button onClick={() => check(false)} disabled={busy} variant="outline" data-testid="admin-email-check-button" className="flex-1 gap-2 rounded-xl"><RefreshCw size={14} /> ଯାଞ୍ଚ</Button>
        <Button onClick={() => check(true)} disabled={busy} data-testid="admin-email-send-test-button" className="flex-1 gap-2 rounded-xl bg-purple-600 hover:bg-purple-700 text-white"><Send size={14} /> Test ଇମେଲ୍ ପଠାନ୍ତୁ</Button>
      </div>
      {error && <div className="text-xs text-red-600" data-testid="admin-email-error">{error}</div>}
      {d && (
        <div className="space-y-2 text-xs text-gray-700" data-testid="admin-email-result">
          <div className="flex items-center justify-between"><span>API key</span>{badge(d.resend_key_configured, d.resend_key_configured ? 'Configured' : 'Missing')}</div>
          <div className="flex items-center justify-between"><span>Sender</span><span className="font-mono text-[10px]" data-testid="admin-email-sender">{d.sender || '—'}</span></div>
          {d.domain && (
            <div className="flex items-center justify-between"><span>Domain {d.domain.name}</span>{badge(verified, d.domain.status)}</div>
          )}
          {d.domain?.dns_records?.length > 0 && !verified && (
            <div className="rounded-lg bg-gray-50 border p-2 space-y-1 overflow-x-auto">
              <div className="font-bold">DNS records ଯୋଡ଼ନ୍ତୁ (Resend ରୁ):</div>
              {d.domain.dns_records.map((r, i) => (
                <div key={i} className="font-mono text-[10px] break-all">{r.type} <b>{r.name}</b> → {r.value}{r.priority != null ? ` (prio ${r.priority})` : ''} [{r.status}]</div>
              ))}
            </div>
          )}
          {d.domain?.error && <div className="text-red-600">{d.domain.error}</div>}
          {d.domain?.hint && <div className="text-amber-700">{d.domain.hint}</div>}
          {d.test_email && (
            <div className="flex items-center justify-between" data-testid="admin-email-test-result">
              <span>Test → {d.test_email.to}</span>{badge(d.test_email.ok, d.test_email.ok ? `Sent (id ${String(d.test_email.id || '').slice(0, 8)}…)` : 'Failed')}
            </div>
          )}
          {d.test_email && !d.test_email.ok && <div className="text-red-600 break-all">{d.test_email.error}</div>}
        </div>
      )}
    </Card>
  );
};
